module.exports = __webpack_public_path__ + "static/media/bg-group.43486919.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/appointment/components/images/bg-group.png
// module id = 897
// module chunks = 0